/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */


export const StepType = Object.freeze({
	SECTION: 'SECTION',
	TASK: 'TASK',
	NOTE: 'NOTE',
	CALL: 'CALL',
	CONTRACT: 'CONTRACT',
})
export const StepVisibility = Object.freeze({
	NOT_SET: 'NOT_SET',
	PRIVATE: 'PRIVATE',
	PUBLIC: 'PUBLIC'
})
export const OwnerEnum = Object.freeze({
	ME: 'ME',
	OTHER: 'OTHER'
})

export const SessionConfirmationStatus = Object.freeze({
	PENDING_CLIENT: 'PENDING_CLIENT',
	PENDING_COACH: 'PENDING_COACH',
	PENDING_PAYMENT: 'PENDING_PAYMENT',
	CONFIRMED: 'CONFIRMED',
	CANCELLED: 'CANCELLED'
})


